import { Component, Input, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { StatoIscritto } from '../../model/iscritti-data';

@Component({
  selector: 'app-tabella-common',
  templateUrl: './tabella-common.component.html',
  styleUrl: './tabella-common.component.scss'
})
export class TabellaCommonComponent {

  @Input('data')
  listaIscrittiStp: any = {
    lista: [],
    componenteTipo: '',
    conteggio: 0,
    id: 0
  }

  @ViewChild('dt') dt!: Table; // controlla perchè messo

  listaCommon: any[] = [];
  initialFlagHandler: boolean = true; // controlla perchè messo
  resetFlag: boolean = false; // controlla perchè messo

  orderColumnName: string = '';
  order: string = 'ASC';
  page: number = 0;
  pageSize: number = 25;
  currentPage: number = 0;

  headersTabella: string[] = [];
  rowsTabella: string[] = [];

  dettaglioIscrittoRoute = '/gestione_albo/gestione_iscritti/dettaglio_iscritto/';


  ordinamento(event: any){

    if(this.initialFlagHandler){
      this.initialFlagHandler = false;
      return;
    }

    this.orderColumnName = event.sortField ? event.sortField : 'codiceFiscale';
    this.order = event.sortOrder === 1 ? 'ASC' : 'DESC'; //-1 discendente / 1 ascendente
    this.page = 0;
    this.pageSize = 25;
    this.currentPage = 0;

    if(this.resetFlag){
      this.resetFlag = false;
      this.dt.reset();
      return;
    }

    //if(event.sortOrder === -1) this.resetFlag = true;

    //this.loadData();
  }

  orderCustom(order: string): number{

    let check = 0;
    if(order === 'ASC') check = 1;
    if(order === 'DESC') check = -1;

    return check;
  }

  //crea il RouterLink per le voci della tabella
  generaRoutingLink(iscritto: any): string{
    return this.dettaglioIscrittoRoute + iscritto.id;
  }

  coloreStato(statoIscritto: StatoIscritto): string{
      let colore = '';
      const id = statoIscritto.codiceCnop;

      if(id === 'A') colore = '#16A34A';
      if(id === 'S') colore = '#CDC103';
      if(id === 'T') colore = '#00BFFE';
      if(id === 'C') colore = '#FBA465';
      if(id === 'R') colore = '#EF5233';
      if(id === 'P') colore = '#BF08FF';

      return colore;
    }

}
